import { render, staticRenderFns } from "./pwa_group_info.vue?vue&type=template&id=032d01a9&scoped=true&"
import script from "./pwa_group_info.vue?vue&type=script&lang=js&"
export * from "./pwa_group_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032d01a9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('032d01a9')) {
      api.createRecord('032d01a9', component.options)
    } else {
      api.reload('032d01a9', component.options)
    }
    module.hot.accept("./pwa_group_info.vue?vue&type=template&id=032d01a9&scoped=true&", function () {
      api.rerender('032d01a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/news/modal/group/tabs/pwa_group_info.vue"
export default component.exports